/**
 * @fileoverview The i18next namespace `@puffin-core/error-handling`'s words register under, and its number.
 * @package @puffin-core/error-handling
 *
 * A **ZERO-IMPORT leaf module**, the discipline every sibling package follows: `@puffin-core/i18n-namespaces` imports
 * this package's `./strings` subpath at app boot, so nothing here may pull the package's handlers in.
 *
 * Namespace #57 `errorHandling`, reserved for this package (puffin-coord `log/stamps.md`, 3:21 AM PDT 2026-10-23). ONE
 * package carries ONE namespace (THINKPAD, 12:55 PM PDT 2026-10-23): D1's errorCode unit 4 landed this scaffold with the
 * error-to-notification mapper's words, and JSDOC-PROP-CONTRACT-001's #57 added `formatApiErrorForDisplay`'s display
 * slots (`display.*`) to the same catalog. `processApiError`'s own English is a LOG line, never copy (Q-57-1 (b)).
 *
 * @module @puffin-core/error-handling/strings/namespace
 */

/** The canonical namespace under which `@puffin-core/error-handling`'s strings live in i18next. */
export const ERROR_HANDLING_NAMESPACE = 'errorHandling';

/** Its number in the ecosystem's namespace roster. */
export const ERROR_HANDLING_NAMESPACE_NUMBER = 57;

export default ERROR_HANDLING_NAMESPACE;
